<template>

    <a class="ad_menu-item ad_menu-item--site"
        href="#"
        v-on:click="showSiteModal" 
        v-if="ready && isAuth && isSiteSelected && isClientSelected">

        <i class="fa fa-map-marker"></i>
        <span class="ad_menu-item__label">{{ currentClient.code }} - {{ currentSite.name }}</span>

    </a>

</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

import { useLogin } from '@/helpers/auth'
import { actions as clientActions } from '@/store/clients'
import { actions as siteActions } from '@/store/sites'
import { actions as utilisateurActions } from '@/store/utilisateurs'

import SiteModale, { SITE_EVENT, SiteBus } from '@/components/siteModale/SiteModale.vue'

export default {

    data() {
        return {
            modale: null,
            ready: false,
            selectedClientId: null,
            selectedSiteCode: null,
            modalOpened: false
        }
    },

    computed: mapState({

        clients: state => state.clients.all,

        clientAddresses: function(state) {

            if ( this.selectedClientId == null ) {
                return []
            }

            let clientAddresses = []
            state.utilisateurs.currentAddresses.forEach(clientAddress => {
                if ( clientAddress.clientId === this.selectedClientId ) {
                    clientAddresses.push(clientAddress)
                }
            });
            return clientAddresses
        },

        currentClient: state => state.clients.current,

        currentSite: state => state.sites.current,

        isAuth: state => ( state.utilisateurs.current !== null ),

        isClientSelected: state => ( state.clients.current !== null ),

        isSiteSelected: state => ( state.sites.current !== null ),

        markets: state => state.sites.markets,

        utilisateur: state => state.utilisateurs.current

    }),

    methods: {

        showSiteModal: function() {
            SiteBus.$emit(SITE_EVENT)
        }
    },

    created() {

        const { isLogged, clientId, siteId } = useLogin()

        /// Si l'utilisateur n'est pas authentifié,
        /// On ne charge rien
        if ( !isLogged ) {
            return
        }

        /// Cas 1: Utilisateur authentitifié mais site de livraison pas encore sélectionné
        if ( clientId == null || siteId == null ) {
            Promise.all([
                this.$store.dispatch(clientActions.GET_ALL),
                this.$store.dispatch(siteActions.GET_MARKETS),
                this.$store.dispatch(utilisateurActions.GET),        
                this.$store.dispatch(utilisateurActions.GET_ADDRESSES)                
            ])
            .then( () => {
                this.clients.forEach( client => {
                    if ( client.id === this.utilisateur.defaultClientId ) {
                        this.selectedClientId = client.id
                    }
                })
                this.ready = true
                this.showSiteModal()
            })
        }

        /// Cas 2: authentifié et site de livraison choisi          
        else {
            Promise.all([
                this.$store.dispatch(clientActions.GET),
                this.$store.dispatch(clientActions.GET_ALL),
                this.$store.dispatch(siteActions.GET),
                this.$store.dispatch(siteActions.GET_MARKETS),
                this.$store.dispatch(utilisateurActions.GET),          
                this.$store.dispatch(utilisateurActions.GET_ADDRESSES)
                
            ])
            .then( () => {
                this.selectedClientId = this.$store.state.clients.currentId
                this.selectedSiteCode = this.$store.state.sites.currentId
                this.ready = true 
            })
        }

        this.modale = new Vue({
            store: this.$store,
            render: createElement => createElement(SiteModale)
        })
        this.modale.$mount(document.body.appendChild(document.createElement('div')))
    },

    name: 'SiteLink'
}
</script>
